import "regenerator-runtime/runtime";
import { initSearch } from "./algolia-search.js";

import {
    copyToClipboard,
    loadVersions,
    toc,
    scrollSpy,
    tabGroups,
    colorSchemeSwitcher,
    quickFilter,
    openSidebar,
    collapseExpand,
    wasThisHelpful,
    getLatestVersion
} from "./modules";

// Init Algolia Search
initSearch();

// Table of contents generation
toc();

// Scroll spy
scrollSpy();

// Load versions from json-file and populate select/option
loadVersions();

// Add copy to clipboard buttons on pre tags
copyToClipboard();

// Tab groups
tabGroups();

// Dark mode
colorSchemeSwitcher();

// Quick Filter configuration reference list
quickFilter();

// Open sidebar on mobile
openSidebar();

// Add chevron icons in sidebar TOC Tree //
collapseExpand();

// Was this helpful
wasThisHelpful();

// Get latest version
getLatestVersion();
